// extracted by mini-css-extract-plugin
export default {"box":"PermisosTab_box__9nFgb","hideBox":"PermisosTab_hideBox__qVCqe"};